// Copyright 2020 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { As2ImportResult } from "datatypes/SoramaWebApi";
import { Api } from "libraries/WebApi/Api";
import { IWebRequestHandler } from "libraries/WebRequestHandler/IWebRequestHandler";
import { ProgressIndicator } from "./../libraries/ProgressIndicator/ProgressIndicator";

@autoinject
export class LinkedAs2ObjectRepository {
    constructor(private readonly webRequestHandler: IWebRequestHandler) {}

    public createAs2Measurement(
        data: Blob,
        projectId: string,
        progressCallback?: (progress: ProgressIndicator) => void
    ): Promise<As2ImportResult> {
        const call = this.webRequestHandler.createPostRequest<As2ImportResult>(
            Api.as2Files + "?projectId=" + projectId,
            data
        );

        if (progressCallback != undefined) {
            call.withUploadProgress(progressCallback).withDownloadProgress(progressCallback);
        }

        return call.send().then((x) => x.content);
    }

    public createAs2Media(
        data: Blob,
        projectId: string,
        progressCallback?: (progress: ProgressIndicator) => void
    ): Promise<As2ImportResult> {
        const call = this.webRequestHandler.createPostRequest<As2ImportResult>(
            Api.as2MediaFiles + "?projectId=" + projectId,
            data
        );

        if (progressCallback != undefined) {
            call.withUploadProgress(progressCallback).withDownloadProgress(progressCallback);
        }

        return call.send().then((x) => x.content);
    }
}
